module.exports = __webpack_public_path__ + "../assets/img/emoji.f29bea74.png";